var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            { attrs: { "drawer-button-disabled": _vm.drawerButtonDisabled } },
            [
              _c(
                "w-toolbar-text",
                {
                  staticClass: "app-title",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              ),
              _vm.contact.ID != 0 && _vm.canDelete
                ? _c(
                    "w-toolbar-item",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.remove()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "trash" } })],
                    1
                  )
                : _vm._e(),
              _vm.canEdit
                ? _c(
                    "w-toolbar-item",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.edit()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "pen" } })],
                    1
                  )
                : _vm._e(),
              _c(
                "w-toolbar-item",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        [
          _c(
            "w-row",
            { attrs: { "no-wrap": "" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-wrap": "" } },
                    [
                      _c("w-tabs", {
                        attrs: { tabs: _vm.tabs },
                        model: {
                          value: _vm.tab,
                          callback: function ($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab",
                        },
                      }),
                      !_vm.$wf.isSmDown
                        ? [
                            _c("w-spacer"),
                            _c(
                              "w-button",
                              {
                                attrs: { disabled: !_vm.canEdit, icon: "pen" },
                                on: {
                                  click: function ($event) {
                                    return _vm.edit()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("common.edit")) + " "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { staticClass: "content", attrs: { tag: "div" } },
            [
              _c(
                "transition",
                { attrs: { name: "fast-fade", mode: "out-in" } },
                [
                  _vm.currentTabKey == "general"
                    ? _c("app-tab-1", { attrs: { contact: _vm.contact } })
                    : _vm.currentTabKey == "addresses"
                    ? _c("app-tab-2", {
                        ref: "Addresses",
                        attrs: { contact: _vm.contact },
                      })
                    : _vm.currentTabKey == "extra-info"
                    ? _c("app-tab-4", { attrs: { contact: _vm.contact } })
                    : _vm.currentTabKey == "extra-fields"
                    ? _c("app-tab-3", {
                        attrs: {
                          value: _vm.contact.ExtraFields,
                          "group-id": _vm.contact.GroupID,
                        },
                      })
                    : _vm.currentTabKey == "documents"
                    ? _c("app-tab-5", { attrs: { contact: _vm.contact } })
                    : _vm.currentTabKey == "price-rules"
                    ? _c("app-tab-6", { attrs: { contact: _vm.contact } })
                    : _c("app-extra-field-tab", {
                        key: "extra-field-" + _vm.tab,
                        attrs: {
                          value: _vm.contact.ExtraFields,
                          tab: _vm.extraFieldTabs[
                            _vm.tab - _vm.extraFieldTabStart
                          ],
                          "name-settings": _vm.extraFieldNamesConfig,
                          readonly: "",
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }